/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-04 16:26:09
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2023-02-13 11:27:12
 * @FilePath: /njyx-frontend-pc/packages/main/src/main.ts
 * @Description:主入口文件
 *
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueViewer from "v-viewer";
import "@packages/share/style/var.css";
import "@packages/share/style/base.css";
//引入业务组件、项目内组件
import component from "@packages/share/components/index";
import microApp from "@micro-zoe/micro-app";
import LinkdUI from "linkd-ui";
import addPath from "@packages/share/utils/addTopNavPath";
import reducePath from "@packages/share/utils/reduceTopNavPath";
import localForage from "localforage";
import "linkd-ui/dist/style.css";
import "@wangeditor/editor/dist/css/style.css";
// 引入本项目style - 在公共share里面
import "@packages/share/style/index.css";
// 按钮权限
import {
  useBtnPermission,
  getBtnListByBtnType,
} from "@packages/share/utils/btnPermission";
import "./permission"; // 路有权限控制
const app = createApp(App as any);
app.config.globalProperties.$isHaveBtn = useBtnPermission; //template 直接访问，因为有this，不能在js中访问
app.config.globalProperties.$getBtnList = getBtnListByBtnType;
app.provide("$isHaveBtn", useBtnPermission); //ts 里面访问
app.provide("$getBtnList", getBtnListByBtnType);

// 跳转控制器 start ts 里面访问
app.provide("$controller", {
  open: function (
    name: string,
    path: string,
    query?: Record<string, string>,
    goPageBtnList?: any
  ) {
    let timeStamp = new Date().getTime();
    router.push({
      path: path,
      query: {
        ...query,
        timeStamp: timeStamp,
      },
    });
    addPath(
      path,
      name,
      {
        ...query,
        timeStamp: timeStamp,
      },
      goPageBtnList
    );
  },
  close: function close(path: string) {
    let timeStamp = new Date().getTime();
    router.replace({
      path: path,
      query: {
        timeStamp: timeStamp,
      },
    });
    reducePath(1, path);
  },
}); //ts 里面访问
// 跳转控制器 end

microApp.start({
  disableScopecss: true, //禁用样式隔离，解决在vue3中样式失效的问题
});

import ElementPlus from "element-plus";
import 'element-plus/dist/index.css'
import zhCn from "element-plus/es/locale/lang/zh-cn";

app.use(ElementPlus, {
  locale: zhCn,
});
app.use(VueViewer);

app.use(LinkdUI, {}).use(router).use(component).mount("#base_goods");
// app.use(LinkdUI).use(router).mount("#base_goods")
